module.exports = __webpack_public_path__ + "assets/d5b7522ac3b5df93a96ac71e8739b083.png";